import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { AppContext } from '@edx/frontend-platform/react';

import { GET_DISCOVER_COURSES } from '../queries/discoverCourses';

export const useDiscoverCourses = () => {
  const { authenticatedUser } = useContext(AppContext);
  const userId = authenticatedUser?.id ?? authenticatedUser?.userId;

  const { data, loading, error } = useQuery(GET_DISCOVER_COURSES, {
    variables: { userId },
    skip: !userId,
  });

  const filteredCourses = React.useMemo(() => {
    if (!data?.discoverCourses) return [];

    const now = new Date();

    const eligibleCourses = data.discoverCourses.filter((course) => {
      const courseDetails = course.details;
      if (!courseDetails) return false;

      if (courseDetails.enrollmentEnd) {
        const enrollmentEndDate = new Date(courseDetails.enrollmentEnd);
        if (enrollmentEndDate < now) return false;
      }

      return true;
    });

    return eligibleCourses.map((course) => {
      // Hidden means an upsell row explicitly says so; a track with no row at
      // all stays visible. That is blendxapi's rule
      // (`visibility_map.get(slug, True)`) and the course-detail panel's.
      //
      // The previous "no visible rows at all -> keep every mode" shortcut got
      // both edges wrong: a track with no row was dropped, and a course with
      // every track hidden showed all of them.
      const visibilityBySlug = new Map(
        (course.modeDetails || []).map((md) => [md?.courseMode, md?.visible]),
      );

      const filteredModes = (course.modes || []).filter(
        (m) => visibilityBySlug.get(m.modeSlug) !== false,
      );

      return { ...course, modes: filteredModes };
    });
  }, [data?.discoverCourses]);

  return {
    discoverCourses: filteredCourses,
    loading,
    error,
  };
};
